import { HtmlListTagImporterBase } from './list-base';
export class HtmlOlTagImporter extends HtmlListTagImporterBase {
    elementTag() {
        return "OL";
    }
}
